import { render, staticRenderFns } from "./fakeForm.vue?vue&type=template&id=237678cd&"
import script from "./fakeForm.vue?vue&type=script&lang=js&"
export * from "./fakeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports